"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var actionHandlersToActions = function actionHandlersToActions(list, arg0, arg1) {
  return list.reduce(function (acc, action) {
    if (typeof action !== 'function') {
      return [].concat((0, _toConsumableArray2["default"])(acc), [action]);
    }

    var res = action(arg0, arg1);

    if (typeof res === 'undefined' || res === null || !('type' in res)) {
      return acc;
    }

    return [].concat((0, _toConsumableArray2["default"])(acc), [res]);
  }, []);
};

var _default = actionHandlersToActions;
exports["default"] = _default;